// Paramètres (tous les espaces) : langue de l'interface, mode nuit et son des notifications.
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { LANGUES, THEMES, definirLangue, definirTheme, langue, theme } from "../services/preferences";
import { CLE_SON_NOTIFICATIONS, jouerSonAlerte, sonActive } from "../services/sonAlerte";
import "./Parametres.css";

export default function Parametres({ onClose }) {
  const [choixLangue, setChoixLangue] = useState(langue);
  const [choixTheme, setChoixTheme] = useState(theme);
  const [son, setSon] = useState(sonActive);

  useEffect(() => {
    const echap = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", echap);
    return () => document.removeEventListener("keydown", echap);
  }, [onClose]);

  const changerLangue = (valeur) => { setChoixLangue(valeur); definirLangue(valeur); };
  const changerTheme = (valeur) => { setChoixTheme(valeur); definirTheme(valeur); };
  const changerSon = (actif) => {
    setSon(actif);
    try { window.localStorage.setItem(CLE_SON_NOTIFICATIONS, actif ? "true" : "false"); } catch { /* indisponible */ }
  };

  // Rendue au niveau de la page : les styles de l'espace (portail parents…) ne la déforment pas.
  return createPortal(
    <div className="ql-param-overlay" onClick={onClose}>
      <div className="ql-param" role="dialog" aria-modal="true" aria-labelledby="ql-param-titre" onClick={(e) => e.stopPropagation()}>
        <div className="ql-param-entete">
          <h2 id="ql-param-titre"><i className="bi bi-gear me-2"></i>Paramètres</h2>
          <button type="button" className="btn-close" onClick={onClose} aria-label="Fermer"></button>
        </div>

        <section className="ql-param-section">
          <h3><i className="bi bi-translate me-2"></i>Langue de l'application</h3>
          <div className="ql-param-choix" role="radiogroup" aria-label="Langue">
            {LANGUES.map(([valeur, libelle]) => (
              <button key={valeur} type="button" role="radio" aria-checked={choixLangue === valeur}
                className={choixLangue === valeur ? "actif" : ""} onClick={() => changerLangue(valeur)}
                translate="no">{libelle}</button>
            ))}
          </div>
          <p className="ql-param-aide">Les leçons, énoncés et messages restent dans leur langue d'origine.</p>
        </section>

        <section className="ql-param-section">
          <h3><i className="bi bi-moon-stars me-2"></i>Apparence</h3>
          <div className="ql-param-choix ql-param-choix--col" role="radiogroup" aria-label="Apparence">
            {THEMES.map(([valeur, libelle]) => (
              <button key={valeur} type="button" role="radio" aria-checked={choixTheme === valeur}
                className={choixTheme === valeur ? "actif" : ""} onClick={() => changerTheme(valeur)}>
                <i className={`bi ${valeur === "clair" ? "bi-sun" : valeur === "sombre" ? "bi-moon" : "bi-phone"} me-2`}></i>{libelle}
              </button>
            ))}
          </div>
        </section>

        <section className="ql-param-section">
          <h3><i className="bi bi-bell me-2"></i>Son des notifications</h3>
          <label className="ql-param-interrupteur">
            <input type="checkbox" checked={son} onChange={(e) => changerSon(e.target.checked)} />
            <span>Jouer un son quand une notification arrive</span>
          </label>
          {son && <button type="button" className="btn btn-sm btn-outline-primary mt-2" onClick={() => jouerSonAlerte({ forcer: true })}>
            <i className="bi bi-volume-up me-1"></i>Tester le son</button>}
        </section>

        <p className="ql-param-aide">Ces réglages sont enregistrés sur cet appareil.</p>
      </div>
    </div>,
    document.body,
  );
}

// Bouton « Paramètres » à placer dans la barre de chaque espace : il ouvre la fenêtre ci-dessus.
export function BoutonParametres({ className = "", avecTexte = false }) {
  const [ouvert, setOuvert] = useState(false);
  return (
    <>
      <button type="button" className={className} onClick={() => setOuvert(true)} title="Paramètres" aria-label="Paramètres">
        <i className="bi bi-gear"></i>{avecTexte && <span className="ms-1">Paramètres</span>}
      </button>
      {ouvert && <Parametres onClose={() => setOuvert(false)} />}
    </>
  );
}
